const colors = [
  { fileName: 'primary_Black.png', hex: '#393939', name: 'Black' },
  { fileName: 'secondary_Black.png', hex: '#393939', name: 'Black' },
  { fileName: 'primary_Blue.png', hex: '#334789', name: 'Blue' },
  { fileName: 'secondary_Blue.png', hex: '#334789', name: 'Blue' },
  { fileName: 'primary_Brown.png', hex: '#594511', name: 'Brown' },
  { fileName: 'secondary_Brown.png', hex: '#594511', name: 'Brown' },
  { fileName: 'primary_Copper.png', hex: '#885829', name: 'Copper' },
  { fileName: 'secondary_Copper.png', hex: '#885829', name: 'Copper' },
  { fileName: 'primary_Crimson.png', hex: '#6d1818', name: 'Crimson' },
  { fileName: 'secondary_Crimson.png', hex: '#6d1818', name: 'Crimson' },
  { fileName: 'primary_Eggshell.png', hex: '#f6eae0', name: 'Eggshell' },
  { fileName: 'secondary_Eggshell.png', hex: '#f6eae0', name: 'Eggshell' },
  { fileName: 'primary_Flame.png', hex: '#c47414', name: 'Flame' },
  { fileName: 'secondary_Flame.png', hex: '#c47414', name: 'Flame' },
  { fileName: 'primary_Gold.png', hex: '#ccb434', name: 'Gold' },
  { fileName: 'secondary_Gold.png', hex: '#ccb434', name: 'Gold' },
  { fileName: 'primary_Green.png', hex: '#0c4c2c', name: 'Green' },
  { fileName: 'secondary_Green.png', hex: '#0c4c2c', name: 'Green' },
  { fileName: 'primary_Maroon.png', hex: '#6d2626', name: 'Maroon' },
  { fileName: 'secondary_Maroon.png', hex: '#6d2626', name: 'Maroon' },
  { fileName: 'primary_Mint.png', hex: '#869e80', name: 'Mint' },
  { fileName: 'secondary_Mint.png', hex: '#869e80', name: 'Mint' },
  { fileName: 'primary_Night.png', hex: '#27364d', name: 'Night' },
  { fileName: 'secondary_Night.png', hex: '#27364d', name: 'Night' },
  { fileName: 'primary_Pink.png', hex: '#bb8992', name: 'Pink' },
  { fileName: 'secondary_Pink.png', hex: '#bb8992', name: 'Pink' },
  { fileName: 'primary_Purple.png', hex: '#421151', name: 'Purple' },
  { fileName: 'secondary_Purple.png', hex: '#421151', name: 'Purple' },
  { fileName: 'primary_Red.png', hex: '#8a1821', name: 'Red' },
  { fileName: 'secondary_Red.png', hex: '#8a1821', name: 'Red' },
  { fileName: 'primary_Sea.png', hex: '#507399', name: 'Sea' },
  { fileName: 'secondary_Sea.png', hex: '#507399', name: 'Sea' },
  { fileName: 'primary_Silver.png', hex: '#afc0bf', name: 'Silver' },
  { fileName: 'secondary_Silver.png', hex: '#afc0bf', name: 'Silver' },
  { fileName: 'primary_Sky.png', hex: '#1280ec', name: 'Sky' },
  { fileName: 'secondary_Sky.png', hex: '#1280ec', name: 'Sky' },
  { fileName: 'primary_Stone.png', hex: '#4e5254', name: 'Stone' },
  { fileName: 'secondary_Stone.png', hex: '#4e5254', name: 'Stone' },
  { fileName: 'primary_Tan.png', hex: '#83785e', name: 'Tan' },
  { fileName: 'secondary_Tan.png', hex: '#83785e', name: 'Tan' },
  { fileName: 'primary_White.png', hex: '#f4eef2', name: 'White' },
  { fileName: 'secondary_White.png', hex: '#f4eef2', name: 'White' },
  { fileName: 'primary_Wood.png', hex: '#a07d53', name: 'Wood' },
  { fileName: 'secondary_Wood.png', hex: '#a07d53', name: 'Wood' },
  { fileName: 'primary_Yellow.png', hex: '#dde655', name: 'Yellow' },
  { fileName: 'secondary_Yellow.png', hex: '#dde655', name: 'Yellow' },
  { fileName: 'primary_Bone.png', hex: '#d4d7b1', name: 'Bone' },
  { fileName: 'secondary_Bone.png', hex: '#d4d7b1', name: 'Bone' },
  { fileName: 'primary_None.png', hex: '', name: 'Empty' },
  { fileName: 'secondary_None.png', hex: '', name: 'Empty' },
  // skin

  { name: 'Beige', hex: '#e5b770', fileName: 'primary_Beige.png' },
  { name: 'Brick', hex: '#8f6e4d', fileName: 'primary_Brick.png' },
  { name: 'Bronze', hex: '#ce955c', fileName: 'primary_Bronze.png' },
  { name: 'Caucasian', hex: '#e6c8aa', fileName: 'primary_Caucasian.png' },
  { name: 'Celestial', hex: '#98b0d8', fileName: 'primary_Celestial.png' },
  { name: 'Chestnut', hex: '#754a27', fileName: 'primary_Chestnut.png' },
  { name: 'Chocolate', hex: '#4c2a1e', fileName: 'primary_Chocolate.png' },
  { name: 'Cinder', hex: '#343434', fileName: 'primary_Cinder.png' },
  { name: 'Dust', hex: '#706e54', fileName: 'primary_Dust.png' },
  { name: 'Grey', hex: '#7b7b7b', fileName: 'primary_Grey.png' },
  { name: 'Honey', hex: '#a38836', fileName: 'primary_Honey.png' },
  { name: 'Jade', hex: '#2e9b5b', fileName: 'primary_Jade.png' },
  { name: 'Lavender', hex: '#81478e', fileName: 'primary_Lavender.png' },
  { name: 'Olive', hex: '#967644', fileName: 'primary_Olive.png' },
  { name: 'Pale', hex: '#f3d6ba', fileName: 'primary_Pale.png' },
  { name: 'Porcelain', hex: '#f4eef2', fileName: 'primary_Porcelain.png' },
  { name: 'Sanguine', hex: '#9a2424', fileName: 'primary_Sanguine.png' },
  { name: 'Skeleton', hex: '#d4d7b1', fileName: 'primary_Skeleton.png' },
  { name: 'Storm', hex: '#3b4c67', fileName: 'primary_Storm.png' },
  { name: 'Sunbeam', hex: '#e4e96d', fileName: 'primary_Sunbeam.png' },
  { name: 'Swarthy', hex: '#8f6527', fileName: 'primary_Swarthy.png' },

  { name: 'Beige', hex: '#e5b770', fileName: 'primary_Beige.png' },
  { name: 'Beige', hex: '#e5b770', fileName: 'secondary_Beige.png' },
  { name: 'Brick', hex: '#8f6e4d', fileName: 'primary_Brick.png' },
  { name: 'Brick', hex: '#8f6e4d', fileName: 'secondary_Brick.png' },
  { name: 'Bronze', hex: '#ce955c', fileName: 'primary_Bronze.png' },
  { name: 'Bronze', hex: '#ce955c', fileName: 'secondary_Bronze.png' },
  { name: 'Caucasian', hex: '#e6c8aa', fileName: 'primary_Caucasian.png' },
  { name: 'Caucasian', hex: '#e6c8aa', fileName: 'secondary_Caucasian.png' },
  { name: 'Celestial', hex: '#98b0d8', fileName: 'primary_Celestial.png' },
  { name: 'Celestial', hex: '#98b0d8', fileName: 'secondary_Celestial.png' },
  { name: 'Chestnut', hex: '#754a27', fileName: 'primary_Chestnut.png' },
  { name: 'Chestnut', hex: '#754a27', fileName: 'secondary_Chestnut.png' },
  { name: 'Chocolate', hex: '#4c2a1e', fileName: 'primary_Chocolate.png' },
  { name: 'Chocolate', hex: '#4c2a1e', fileName: 'secondary_Chocolate.png' },
  { name: 'Cinder', hex: '#343434', fileName: 'primary_Cinder.png' },
  { name: 'Cinder', hex: '#343434', fileName: 'secondary_Cinder.png' },
  { name: 'Dust', hex: '#706e54', fileName: 'primary_Dust.png' },
  { name: 'Dust', hex: '#706e54', fileName: 'secondary_Dust.png' },
  { name: 'Grey', hex: '#7b7b7b', fileName: 'primary_Grey.png' },
  { name: 'Grey', hex: '#7b7b7b', fileName: 'secondary_Grey.png' },
  { name: 'Honey', hex: '#a38836', fileName: 'primary_Honey.png' },
  { name: 'Honey', hex: '#a38836', fileName: 'secondary_Honey.png' },
  { name: 'Jade', hex: '#2e9b5b', fileName: 'primary_Jade.png' },
  { name: 'Jade', hex: '#2e9b5b', fileName: 'secondary_Jade.png' },
  { name: 'Lavender', hex: '#81478e', fileName: 'primary_Lavender.png' },
  { name: 'Lavender', hex: '#81478e', fileName: 'secondary_Lavender.png' },
  { name: 'Olive', hex: '#967644', fileName: 'primary_Olive.png' },
  { name: 'Olive', hex: '#967644', fileName: 'secondary_Olive.png' },
  { name: 'Pale', hex: '#f3d6ba', fileName: 'primary_Pale.png' },
  { name: 'Pale', hex: '#f3d6ba', fileName: 'secondary_Pale.png' },
  { name: 'Porcelain', hex: '#f4eef2', fileName: 'primary_Porcelain.png' },
  { name: 'Porcelain', hex: '#f4eef2', fileName: 'secondary_Porcelain.png' },
  { name: 'Sanguine', hex: '#9a2424', fileName: 'primary_Sanguine.png' },
  { name: 'Sanguine', hex: '#9a2424', fileName: 'secondary_Sanguine.png' },
  { name: 'Skeleton', hex: '#d4d7b1', fileName: 'primary_Skeleton.png' },
  { name: 'Skeleton', hex: '#d4d7b1', fileName: 'secondary_Skeleton.png' },
  { name: 'Storm', hex: '#3b4c67', fileName: 'primary_Storm.png' },
  { name: 'Storm', hex: '#3b4c67', fileName: 'secondary_Storm.png' },
  { name: 'Sunbeam', hex: '#e4e96d', fileName: 'primary_Sunbeam.png' },
  { name: 'Sunbeam', hex: '#e4e96d', fileName: 'secondary_Sunbeam.png' },
  { name: 'Swarthy', hex: '#8f6527', fileName: 'primary_Swarthy.png' },
  { name: 'Swarthy', hex: '#8f6527', fileName: 'secondary_Swarthy.png' },
]

export default colors
